import { Box, Typography } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import SmartToyRoundedIcon from '@mui/icons-material/SmartToyRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import PriceCheckRoundedIcon from '@mui/icons-material/PriceCheckRounded';
import InsightsRoundedIcon from '@mui/icons-material/InsightsRounded';
import StaticPage from '../../components/StaticPage';
import ProfileSection from '../../components/ProfileSection';

const features = [
    {
        icon: <SearchRoundedIcon fontSize="small" />,
        title: 'Filtered creator search',
        body: 'Browse every creator on the platform and narrow the list by platform (Instagram, TikTok, YouTube and more) and content category until you find the right fit.',
    },
    {
        icon: <SmartToyRoundedIcon fontSize="small" />,
        title: 'AI Bot',
        body: "Answer a few quick questions in the chat panel and the assistant surfaces matching creators for you, no manual filtering required.",
    },
    {
        icon: <BoltRoundedIcon fontSize="small" />,
        title: 'Live AI Search',
        body: 'Pull fresh, ranked posts for a platform and category straight from the source, complete with engagement numbers and sentiment on each post.',
    },
    {
        icon: <BadgeRoundedIcon fontSize="small" />,
        title: 'Verified creator profiles',
        body: 'Every profile shows the categories a creator covers, which platforms they run, and badges like Top Creator or Responds Fast at a glance.',
    },
    {
        icon: <PriceCheckRoundedIcon fontSize="small" />,
        title: 'Transparent pricing',
        body: 'Reel, story and live rates are listed on the creator profile itself, so you know the cost of a collaboration before you reach out.',
    },
    {
        icon: <InsightsRoundedIcon fontSize="small" />,
        title: 'Engagement & sentiment',
        body: "Where available, follower counts, engagement rate and audience sentiment are shown right on the creator's platform cards.",
    },
];

export default function FeaturesPage() {
    return (
        <StaticPage title="Features" subtitle="Everything The Creator Match gives you to find and book the right creator.">
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 3 }}>
                {features.map((f) => (
                    <ProfileSection key={f.title} icon={f.icon} title={f.title} sx={{ mb: 0, height: '100%' }}>
                        <Typography color="text.secondary">{f.body}</Typography>
                    </ProfileSection>
                ))}
            </Box>
        </StaticPage>
    );
}
